import {useDispatch, useSelector} from 'react-redux'
import {FOOTER_OFFER_COMPONENT} from 'components/Accommodation/RoomsDetailOverlayContainer/constants'
import {useHotelRoomsFilters} from 'hooks/useHotelRoomsFilters'
import {getRoomOfferAnalyticsContexts} from 'middleware/analytics/selectors'

import {getQueryStringObject} from '@vio/core/src/_web/utils/url'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Page,
  Team
} from '@vio/core/src/analytics/types/Events'
import {Offer} from '@vio/core/src/offer/types/offer'
import {roomsFilterListToMap} from '@vio/core/src/room/business/utils/filters'

type Props = {
  offer: Offer
}

export const useTrackRoomOfferViewed = ({offer}: Props) => {
  const dispatch = useDispatch()
  const {activeRoomsFilters} = useHotelRoomsFilters()

  const analyticsContext = useSelector(state =>
    getRoomOfferAnalyticsContexts(state, offer.id)
  )

  return {
    trackOfferViewed: () => {
      dispatch(
        trackEvent({
          category: Category.User,
          entity: Entity.RoomOffer,
          action: Action.Viewed,
          team: Team.Select,
          page: Page.Accommodation,
          component: FOOTER_OFFER_COMPONENT,
          payload: {
            roomFilterApplied: activeRoomsFilters.length > 0,
            allSelectedRoomFilters: roomsFilterListToMap(activeRoomsFilters),
            srpSearchId: getQueryStringObject()?.srpSearchId
          },
          analyticsContext
        })
      )
    }
  }
}
